/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { selectConsent } from '../../redux/actions/auth';
import styles from './UserConsent.module.css';

function ConsentCheckbox({ language = 'en' }) {
  const dispatch = useDispatch();
  const consentSelection = useSelector((state) => state.auth.consentSelection);

  const handleCheckboxChange = (value) => {
    dispatch(selectConsent(value));
  };

  const consentText = {
    id: {
      paragraph:
        'Sushiroll memberikan layanan tambahan kepada Pengguna/Calon Pengguna sehingga dapat turut menikmati berbagai informasi terkini dari layanan/ produk, promosi, pemberitaan yang dipersonalisasi dari Sushiroll ataupun afiliasi yang telah bekerjasama. \n\nAtas hal tersebut, Sushiroll ataupun afiliasinya menjalankan aktifitas marketing/penawaran dan layanan tambahan lainnya dengan memanfaatkan informasi yang telah diberikan Pengguna/Calon Pengguna pada layanan/produk yang digunakan. \n\nPengguna/Calon Pengguna dapat mengajukan penarikan persetujuan penggunaan tertentu sebagaimana tersebut diatas melalui cabang yang ditentukan.',
      consent_yes:
        'Ya, saya ingin mengikuti layanan tambahan dan mengijinkan untuk menggunakan informasi yang telah saya berikan.',
      consent_no: 'Tidak, terimakasih. Saya melewatkan penawaran ini.'
    },
    en: {
      paragraph:
        'Sushiroll provides additional services to Consumers/Prospective customers can also enjoy a variety of information the latest services/products, promotions, news personalized from Sushiroll or existing affiliate cooperate. Due to this, Sushiroll or its affiliates carry out marketing activities/offers and additional services others by utilizing the information that has been provided Customers/Prospective Consumers on the services/products used. Consumers/Prospective Consumer can apply for a withdrawal certain use approval as mention above through specified branch.',
      consent_yes:
        'Yes, I would like to participate in additional services and allow you to use the information I have provided.',
      consent_no: 'No, thank you. I missed this offer'
    }
  };

  return (
    <div className={styles['checkbox-container']}>
      <p>{consentText[language].paragraph}</p>
      <div className={styles['round']}>
        <div className={styles['checkboxWrapper']}>
          <input
            type='checkbox'
            id='yes'
            checked={consentSelection === true}
            onChange={() => handleCheckboxChange(true)}
          />
          <label htmlFor='yes' />
        </div>
        <span>{consentText[language].consent_yes}</span>
      </div>
      <div className={styles['round']}>
        <div className={styles['checkboxWrapper']}>
          <input
            type='checkbox'
            checked={consentSelection === false}
            onChange={() => handleCheckboxChange(false)}
            id='no'
          />
          <label htmlFor='no' />
        </div>
        <span>{consentText[language].consent_no}</span>
      </div>
    </div>
  );
}

export default ConsentCheckbox;
